/**
 * Content-Design-authored copy for the pre-renewal window preview route —
 * screen 8 (TG-5, resolving DEBT-20261015-p9rw; design_handoff_renewals_
 * portal_H2/README.md "Screen 8 — Pre-renewal window preview" and
 * screens/08-PreRenewalPreview.dc.html). Single state. `windowOpensOn` is
 * a merge field substituted at render time — this is the only authored
 * sentence, copied byte for byte from H2 with the bracketed placeholder
 * replaced by a real, port-supplied, formatted date.
 */
export const renewalPreviewContent = {
  noActionNeeded: "No action is needed at this time.",
  emailNoticePrefix: "We will email you a secure link to complete your renewal on ",
  emailNoticeSuffix: ".",
} as const;
